import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import prescription from './modules/prescription'
import getters from './getters'
import keepAlive from './modules/keepAlive'
import aiIdentify from './modules/aiIdentify'
import patientList from "@/store/modules/patientList";

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    user,
    prescription,
    keepAlive,
    aiIdentify,
    patientList
  },
  getters
})

export default store
